import React, { useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import SvgIcon from "../../../../../../Utils/CommonComponents/CommonIcons/CommonSvgIcons";
import { toast } from "react-toastify";
import axios from "axios";
import {
  getAPIURL,
  getAPIURLAWS,
  getUserID,
} from "../../../../../../services/helper";
import Swal from "sweetalert2";
import http from "../../../../../../services/http";
import { useDispatch } from "react-redux";
import {
  clearChat,
  deleteChat,
} from "../../../../../../ReduxToolkit/Reducers/ChatReducer";

export default function ContactEdit({ className, id, sender, recipient }) {
  console.log(sender, recipient);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const api_url = getAPIURL();
  const api_url_aws = getAPIURLAWS();
  const dispatch = useDispatch();

  const handleClearChat = async () => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "All chat messages will be removed!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
      });

      if (!result.isConfirmed) return;

      const resp = await http.delete(`${api_url_aws}/chats`, {
        data: {
          sender,
          recipient,
        },
      });
      if (resp.data.success) {
        toast.success("chat deleted successfully");
        dispatch(clearChat(id));
      } else {
        toast.error(resp?.data?.message);
      }
      console.log(resp);
    } catch (error) {
      toast.error(error);
      console.log(error);
    }
  };

  const handleDeleteChat = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This Chat Will Be Deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    });

    if (result.isConfirmed) {
      try {
        const resp = await http.delete(`${api_url_aws}/chats`, {
          data: {
            sender,
            recipient,
          },
        });
        if (resp.data.success) {
          toast.success("chat deleted successfully");
          dispatch(deleteChat(id));
        } else {
          toast.error(resp?.data?.message);
        }
        console.log(resp);
      } catch (error) {
        toast.error(error);
        console.log(error);
      }
    }
  };
  return (
    <div className={`contact-edit ${className}`}>
      <Dropdown isOpen={dropdownOpen} toggle={toggle}>
        <DropdownToggle color="transparent d-flex align-items-center">
          <SvgIcon iconId="menubar" />
        </DropdownToggle>
        <DropdownMenu end={true}>
          <DropdownItem onClick={handleClearChat}>{"Clear Chat"}</DropdownItem>
          <DropdownItem onClick={handleDeleteChat}>
            {"Delete Chat"}
          </DropdownItem>
          {/* <DropdownItem>{"Add to favorites"}</DropdownItem> */}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
}
